/**
 * This file has functions for running web workers without having to specify an external file, just a function to run.
 * Its pretty useless unless you don't need to import anything, or at least much of anything. It also trips over babel
 * transpilation
 */

const toBlobUrl = strings => {
  return URL.createObjectURL(new Blob(strings, {type: 'text/javascript' }))
}
export function createWorker(
  fn,
  importScripts = [],
  ) {

  let blob = toBlobUrl(
    importScripts.reduce((sum, fn) => {
      return sum.concat(['importScripts(', `"${toBlobUrl([fn])}"`, ');'])
    }, [])
      .concat([
        'self.onmessage = ',
        fn.toString()
      ])
  );
  return new Worker(blob);
}

export const runInWorker = (fns)  => data => {
  return new Promise((resolve, reject) => {
    const worker = createWorker(fn)
    const done = e => {
      worker.removeEventListener('message', done)
      resolve(e.data)
    }
    worker.addEventListener('message', done)
    worker.postMessage(data)
  })

}

function echo(event) {
  self.postMessage(event.data)
}

/**
 * builder to specify context for passing to an inline web worker
 * @returns {object}
 * @constructor
 */
export const WorkerBuilder = () => {
  let fn = echo
  let imports = []
  const self = {
    withHandler(handlerFn) {
      fn = handlerFn
      return self
    },
    /** makes specified JSON serializable values available in scope by their name specified in the object argument */
    withValues(object) {
      for (let [k, v] of Object.entries(object)) {
        imports.push(`var ${k} = JSON.parse(${JSON.stringify(JSON.stringify(v))})`)
      }
      return self
    },
    /** makes specified fnToImport available in scope by its name.
     * fnToImport external scope variables must be defined by previous imports */
    withFunction(fnToImport) {
      imports.push(fnToImport.toString())
      return self
    },
    /** passes data to the web worker
     * and returns a promise resolved to whatever message the worker posted (`self.postMessage(...)`) */
    run(data) {
      return new Promise((resolve, reject) => {
        const worker = createWorker(fn, imports)
        const done = e => {
          worker.removeEventListener('message', done)
          resolve(e.data)
        }
        worker.addEventListener('message', done)
        worker.postMessage(data)
      })
    }
  }
  return self
}
